<template>
  <div class="payment-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">ALL USERS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search users..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="allUsers"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.user_role }}</td>
          <td>{{ props.item.phone_number }}</td>
          <td class="font-weight-medium">{{ props.item.full_name }}</td>
          <td>{{ props.item.email }}</td>
          <td>{{ props.item.customer_code_kes }}</td>
          <td>{{ props.item.customer_code_usd }}</td>
          
          <!-- ONLY CHANGE: Clickable Wallet Balance -->
          <td data-label="Wallet Balance">
            <router-link 
              v-if="props.item.public_id"
              :to="{ name: 'UserWalletTransactions', params: { user_id: props.item.public_id }}"
              class="wallet-balance-link"
            >
              <div class="wallet-balance">
                <div class="balance-usd">USD {{ formatPrice(props.item.wallet_balance_usd || 0) }}</div>
                <div class="balance-kes">KES {{ formatPrice(props.item.wallet_balance_kes || 0) }}</div>
              </div>
            </router-link>
            <div v-else class="wallet-balance">
              <div class="balance-usd">USD {{ formatPrice(props.item.wallet_balance_usd || 0) }}</div>
              <div class="balance-kes">KES {{ formatPrice(props.item.wallet_balance_kes || 0) }}</div>
            </div>
          </td>
          
          <td data-label="Added On">{{ formated_date(props.item.registered_on) }}</td>
          <td data-label="Status">
            <v-chip 
              small 
              :color="getStatusColor(props.item.active_status)"
              text-color="white"
              class="status-chip"
            >
              {{ props.item.active_status }}
            </v-chip>
          </td>
          <td>
  <v-btn 
    v-if="localData.user_type_id !== 'd06b1e38'"
    depressed 
    small 
    @click="openUser(props.item.public_id)"
    class="futuristic-btn action-btn"
    color="#587e27"
  >
    View User
  </v-btn>
  <span v-else class="text-muted">—</span>
</td>
        </template>
        <template slot="footer">
          <td :colspan="columns.length" class="download-section">
            <vue-json-to-csv
              :json-data="allUsers"
              csv-title="Users List"
              :labels="{
                registered_on: { title: 'Created At' },
                registered_by: { title: 'Created By' },
                user_role: { title: 'User Role' },
                full_name: { title: 'Name' },
                email: { title: 'Email' },
                customer_code_kes: { title: 'Customer Code(KES)' },
                customer_code_usd: { title: 'Customer Code(USD)' },
                wallet_balance_usd: { title: 'Wallet Balance (USD)' },
                wallet_balance_kes: { title: 'Wallet Balance (KES)' },
                active_status: { title: 'Active Status' },
              }"
            >
              <v-btn class="futuristic-btn download-btn">
                <v-icon left>cloud_download</v-icon>
                Download CSV
              </v-btn>
            </vue-json-to-csv>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>

      <v-container class="action-buttons">
        <v-btn
          depressed
          @click="getMore()"
          color="#2196f3"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>add</v-icon>
          GET MORE
        </v-btn>
        <v-btn
          depressed
          @click="getAllUsers()"
          color="#9e9e9e"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>list</v-icon>
          GET ALL
        </v-btn>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
export default {
  components: { VueJsonToCsv },
  data() {
    return {
      localData: JSON.parse(localStorage.getItem("unem")),
      search: "",
      page: 2,
      columns: [
        {
          text: "User Role",
          value: "user_role",
          class: "table-header"
        },
        {
          text: "Phone Number",
          value: "phone_number",
          class: "table-header"
        },
        {
          text: "Name",
          value: "full_name",
          class: "table-header"
        },
        {
          text: "Email",
          value: "email",
          class: "table-header"
        },
        {
          text: "Customer Code (KES)",
          value: "customer_code_kes",
          class: "table-header"
        },
        {
          text: "Customer Code (USD)",
          value: "customer_code_usd",
          class: "table-header"
        },
        {
          text: "Wallet Balance",
          value: "wallet_balance_usd",
          class: "table-header"
        },
        {
          text: "Added On",
          value: "created_at",
          class: "table-header"
        },
        {
          text: "Status",
          value: "active_status",
          class: "table-header"
        },
        {
          text: "Action",
          value: "",
          class: "table-header"
        },
      ],
    };
  },
  methods: {
    getStatusColor(status) {
      if (status === 'Active') return '#44bd32';
      if (status === 'Suspended') return '#fbc531';
      return '#9e9e9e';
    },
    openUser: function (publicId) {
      this.$router.push({
        name: "User",
        params: {
          user_id: publicId,
        },
      });
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0.00';
      return parseFloat(price).toLocaleString('en-KE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    getMore() {
      this.loading = true;

      if (this.page === 2) {
        this.$store.dispatch("get_more_users", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_users", this.page);
        this.page = this.page + 1;
      }
    },
    getAllUsers() {
      this.loading = true;
      let page = 0;
      this.$store.dispatch("get_more_users", page);
    },
  },
  created() {
    if (this.localData.user_type_id === "35fcfdaf") {
      this.$store.dispatch(
        "get_institution_users2",
        this.localData.instiution_id
      );
    } else {
      this.$store.dispatch("get_all_users");
    }
  },
};
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px 0;
}

.download-section {
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

.download-btn {
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
  color: white !important;
}

.action-buttons {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

.status-chip {
  border-radius: 12px;
  font-weight: 500;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Wallet Balance Styling */
.wallet-balance {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.wallet-balance-link {
  text-decoration: none;
  cursor: pointer;
}

.wallet-balance-link:hover .balance-usd,
.wallet-balance-link:hover .balance-kes {
  text-decoration: underline;
}

.balance-usd {
  color: #2980b9;
  font-weight: 600;
  font-size: 12px;
}

.balance-kes {
  color: #27ae60;
  font-weight: 600;
  font-size: 12px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>